var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../classes/runtime/Runtime';
import { MenubarUserEmail } from './MenubarUserEmail';
let MenubarUser_ = class MenubarUser_ extends React.PureComponent {
    get schlaukopfLogo() {
        const { app } = this.props;
        return (React.createElement("div", { style: { fontFamily: '"Roboto", sans-serif', paddingTop: 1, paddingLeft: 3 }, onMouseEnter: () => {
                const x = runtime.streamedPackages.Lazy;
            } },
            React.createElement("span", { style: { color: 'rgb(238, 238, 238)', fontSize: 16, textShadow: 'rgb(0, 0, 0) 3px 5px 10px' } }, runtime.isDevelopmentStage ? 'Dev' : 'Schlaukopf'),
            React.createElement("span", { style: { color: '#428bca' } }, runtime.isDevelopmentStage ? '.schlaukopf' : `.${app.appHost.domainEnding}`)));
    }
    get img() {
        return null;
        const { app } = this.props;
        if (app.appMeasure.appWidthInPixel < 1300)
            return null;
        return (React.createElement("img", { style: { flex: '0 0 28px', maxWidth: 35, maxHeight: 35, alignSelf: 'center', opacity: 0.8 }, src: (app.user && app.user.photoURL) || '/static/img/menubar_user/avatars/grundschule/default.png' }));
    }
    render() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    display: 'flex',
                    cursor: 'pointer',
                    marginLeft: 10,
                } },
                this.img,
                React.createElement("div", { style: { flex: '1 1 auto', paddingLeft: 4 } },
                    this.schlaukopfLogo,
                    React.createElement(MenubarUserEmail, { app: app }))),
            this.userMenu,
            this.userDialogList));
    }
    get userMenu() {
        const { app } = this.props;
        if (!app.menubar.menubarUser.isUserMenuOpen)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { MenubarUserMenu_ } = runtime.streamedPackages.Lazy.components;
        return React.createElement(MenubarUserMenu_, { app: app });
    }
    get userDialogList() {
        const { app } = this.props;
        if (!app.menubarUser.dialogs.isAnyUserDialogShown)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { MenubarUserDialogList } = runtime.streamedPackages.Lazy.components;
        return React.createElement(MenubarUserDialogList, { app: app });
    }
};
MenubarUser_ = __decorate([
    observer
], MenubarUser_);
export { MenubarUser_ };
